<template>
  <div>
    <div v-if="obat && obat.length">
      <div class="d-flex flex-between my-3">
        <h4 class="text-uppercase mb-0">Pemberian Obat dan Alat Kesehatan</h4>
        <router-link
          :to="
            `/operasi/form-obat/${$route.params.id_ralan}/${$route.params.id}?fromTab=2`
          "
          class="btn btn-with-icon-left btn-primary text-uppercase"
        >
          <i class="material-symbols-outlined">create</i>
          Ubah Data Obat dan Alkes
        </router-link>
      </div>
      <div style="position:relative">
        <table v-if="obat.length" class="responsive">
          <thead>
            <th>KODE</th>
            <th>NAMA BARANG</th>
            <th>JENIS OBAT</th>
            <th>LOKASI</th>
            <th>HARGA/PC</th>
            <th>JUMLAH</th>
            <th>EMBALASE</th>
            <th>TUSLAH</th>
            <th>SUB TOTAL</th>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in obat.filter((item) => !item.deleted)"
              v-bind:key="index + item.id + Math.random(1024)"
            >
              <td>{{ item.kode }}</td>
              <td>{{ item.nama }}</td>
              <td>{{ item.jenis }}</td>
              <td>{{ item.lokasi }}</td>
              <td>{{ convertToRupiah(item.harga) }}</td>
              <td>{{ item.jumlah }}</td>
              <td>{{ convertToRupiah(item.embalase) }}</td>
              <td>{{ convertToRupiah(item.tuslah) }}</td>
              <td>{{ convertToRupiah(item.sub_total) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <EmptyState v-else :data="empty" />
  </div>
</template>

<script>
// @ is an alias to /src
// import SearchResult from '@/components/SearchResult.vue'
// import InputMoney from "@/components/InputMoney.vue";
// import InputNumber from "@/components/InputNumber.vue";
import { convertToRupiah } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { dataOperasi } from "@/data/OperasiForm.js";
import EmptyState from "@/components/EmptyState.vue";
export default {
  props: { ralan: Object, operasi: Object },
  name: "OperasiFormObat",
  components: {
    EmptyState,
  },
  data: () => {
    return {
      empty: {
        img: "/img/nurse.svg",
        title: "Belum ada obat dan alkes operasi",
        content:
          "Isi data pemberian obat dan alkes dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/operasi/form-obat/",
        label: "input obat dan alkes operasi",
      },
      data: dataOperasi,
      detailTop: null,
      id_operasi: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      saveSuccess: false,
      saveFailed: false,
      n: 0,
      s_obat: "",
      r_obat: [],
      obat: [],
      a_obat: false,
      l_obat: false,
      isError: false,
      jumlah: [],
      embalase: [],
      tuslah: [],
      convertToRupiah: convertToRupiah,
    };
  },
  methods: {
    save: async function() {
      this.handleForm();
    },
    continue: function() {
      this.$router.push(
        `/operasi/form-biaya/${this.$route.params.id_ralan}/${this.$route.params.id}`
      );
    },
    saveAndContinue: async function() {
      this.handleForm(this.continue);
    },
    handleForm: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n = this.obat.filter(
          (item) => !(item.deleted && !item.id_operasi_obat)
        ).length;

        this.obat.forEach(async function(item) {
          //n-=1;
          if (!item.deleted) {
            let body = `id_operasi=${self.id_operasi}&id_obat=${item.id}&harga=${item.harga}&jumlah=${item.jumlah}&embalase=${item.embalase}&tuslah=${item.tuslah}&sub_total=${item.sub_total}`;
            if (!item.id_operasi_obat) {
              await self.saveData(body);
            } else {
              await self.saveData(body, item.id_operasi_obat);
            }
          } else {
            if (item.id_operasi_obat) {
              await self.deleteData(item.id_operasi_obat);
            }
          }
        });
      } else {
        ////console.log(valid);
      }
    },
    async saveData(body, id) {
      try {
        if (id) {
          let result = await this.$store.state.HTTP_ENC.put(
            `operasi_obat/${id}`,
            body
          );
          ////console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `operasi_obat`,
            body
          );
          ////console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        ////console.log(e);this.saveFailed=true;this.saveSuccess=false;
      }
    },
    async deleteData(id) {
      try {
        let result = await this.$store.state.HTTP_ENC.delete(
          `operasi_obat/${id}`
        );
        ////console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        ////console.log(e);this.saveFailed=true;this.saveSuccess=false;
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.$router.push(
            `/operasi/form-biaya/${that.$route.params.id_ralan}/${that.$route.params.id}`
          );
        }, 1000);
      }
    },
    handleChange(e) {
      // if (e.target.type == "file") {
      //   if(e.target.files && e.target.files.length) { this.formSet[e.target.name] = e.target.files[0]; }
      // } else {
      //   this.formSet[e.target.name] = e.target.value;
      // }
      let name = e.target.name.split("-")[0];
      let index = e.target.name.split("-")[1];
      this.obat[index][name] = parseInt(e.target.value || 0);
      ////console.log(this.obat[index][name]);
      this.obat[index]["sub_total"] =
        this.obat[index].jumlah * this.obat[index].harga +
        this.obat[index].embalase +
        this.obat[index].tuslah;
      this.obat.splice(index, 1, this.obat[index]);
      ////console.log(this.obat[index]);
      // this.updateForm();
    },

    updateForm() {
      // this.obatForm[0].columns[0].value=String(this.formSet['id_petugas']);
      // this.obatForm[0].columns[1].value=String(this.formSet['id_dokter']);
      // this.labForm[0].columns[0].value=String(this.formSet['id_petugas_lab']);
      // this.labForm[0].columns[1].value=this.formSet['lab_type'];
    },
    validateForm: function() {
      let valid = true;
      // let self = this;
      return valid;
    },
    fetchData: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi_obat?id_operasi=${this.$route.params.id}`
        );
        let self = this;
        self.obat = [];
        ////console.log(result);
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_operasi_obat = item.id;
            item.id = item.obat.id;
            item.kode = item.obat.kode;
            item.nama = item.obat.nama;
            item.jenis = item.obat.jenis;
            item.lokasi = item.obat.lokasi;
            self.obat.push(item);
          });
          self.obat = self.obat.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    search: async function(type) {
      ////console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;
      let url = "obat";
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?q=${this["s_" + type]}`
        );
        ////console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            item.formatted_harga = self.convertToRupiah(item.harga);
            return item;
          });
          ////console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      if (!this[type].find((el) => el.id == item.id)) {
        item.jumlah = 1;
        item.embalase = 0;
        item.tuslah = 0;
        item.sub_total = item.harga;
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      ////console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      ////console.log(this[type]);
    },
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.empty.link +=
      this.$route.params.id_ralan + "/" + this.$route.params.id + "?fromTab=2";
    this.id_operasi = this.$route.params.id;
    await this.fetchData();
  },
};
</script>
